// extracted by mini-css-extract-plugin
export default {"formItemRight":"FormItemRight_formItemRight__E4mQ9","form":"FormItemRight_form__YuxWW"};